const classSelectorRegex = /\.[a-z_][a-z0-9_-]*(?![^()]*\))/gi;

export default classSelectorRegex;
